import * as couponService from '@cart-services/core/couponService'
import { useFpCampaignCouponService } from '@cart-services/hooks/useFpCampaignCouponService'
import { type MergedCouponCriterion } from '@cart-services/types'
import { RegularGiveawaySelect } from '@cart-ui/RegularGiveawaySelect/RegularGiveawaySelect'
import { Box } from '@pets-ui/Box/Box'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { fieldRefHelper } from '@utils/fieldRefHelper'
import { Controller, useFormContext } from 'react-hook-form'
import { useContextCampaignCart } from '../CartProvider/CampaignCartProvider'
import { type CartFormValues } from '../CartProvider/CartFormProvider'

export interface RegularGiveawaySelectControllerProps {
  index: number
  criterion: MergedCouponCriterion
  isLastItem: boolean
}

export const RegularGiveawaySelectController = (props: RegularGiveawaySelectControllerProps) => {
  const { index, criterion, isLastItem } = props
  const { campaignId, countryCode, campaignCode, currency } = useContextCampaignCart()
  const { control, setValue } = useFormContext<CartFormValues>()
  const { updateSelectedRegularGiveaways, selectedCouponGiveawayMap } = useFpCampaignCouponService(campaignId, countryCode, campaignCode)
  const {
    couponCriterionId,
    displayName,
    isAllUnavailable,
    isApplied,
    amount,
    value,
    moreAmount,
    moreQuantity,
    count,
    options,
    disabled,
  } = couponService.getRegularGiveawaySelectProps(criterion, selectedCouponGiveawayMap)

  if (amount === null) return null

  return (
    <Controller
      key={couponCriterionId}
      name={`regularGiveaways.${index}`}
      control={control}
      render={({ field: { ref }, fieldState: { error } }) => (
        <>
          <RegularGiveawaySelect
            rootRef={fieldRefHelper(ref)}
            displayName={displayName}
            isApplied={isApplied}
            currency={currency}
            moreAmount={moreAmount}
            moreQuantity={moreQuantity}
            count={count}
            options={options}
            amount={amount}
            disabled={disabled}
            isAllUnavailable={isAllUnavailable}
            shouldHideProgressLine={isLastItem}
            error={!!error}
            onChange={([productId, projectCode, sku]) => {
              if (productId && projectCode) {
                setValue(`regularGiveaways.${index}`, productId, { shouldValidate: true })
                updateSelectedRegularGiveaways(couponCriterionId, {
                  product_id: productId,
                  project_code: projectCode,
                  sku,
                })
              }
            }}
            value={value?.sku ? [value.product_id, value.project_code, value.sku] : []}
          />
          {!!error && <Box ml={11}><Text variant="caption" color={colors.red600}>{error.message}</Text></Box>}
        </>
      )}
    />
  )
}
